export default {"src":"/_next/static/media/patna.d6801a7e.svg","height":314,"width":595};